import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";

// FireCMS 內部仍會初始化主題，必須在掛載前固定其偏好，避免系統深色覆寫 light。
localStorage.setItem("prefers-dark-mode", "false");

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
